/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo } from 'react';
import { StyleSheet, View, Dimensions, TouchableOpacity } from 'react-native';
import Clipboard from '@react-native-clipboard/clipboard';
import Toast from 'react-native-toast-message';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { currency } from '@global/helpers';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import SelectBox from '@components/form/SelectBox';
import ModalFull from '@components/modal/ModalFull';
import { Loader } from '@components/screen/Layout';
import ScrollContainer from '@components/global/ScrollContainer';

import PropTypes from 'prop-types';
import { isQuotationAmountDiff } from '@global/helpers';

const propTypes = {
  data: PropTypes.object,
  withoutDiscount: PropTypes.bool,
  withoutPrice: PropTypes.bool,
  withoutQuantity: PropTypes.bool,
  withoutCurrency: PropTypes.bool,
  textWidth: PropTypes.number,
  showRemove: PropTypes.bool,
  isShowStock: PropTypes.bool,
  orderStatus: PropTypes.string,
  isDetail: PropTypes.bool,
  orderId: PropTypes.string,
  promotionRules: PropTypes.array,
  onSelectPromo: PropTypes.func,
  onCancelPromo: PropTypes.func,
  onReady: PropTypes.func,
  onShow: PropTypes.func,
  onRemove: PropTypes.func,
  customer: PropTypes.object,
  sales_team: PropTypes.object,
  isQuotation: PropTypes.bool,
  isShowDiscount2: PropTypes.bool,
  setDetailPromoData: PropTypes.func,
  isShowDetailPromo: PropTypes.bool,
};

const defaultProps = {
  data: {},
  withoutDiscount: false,
  withoutPrice: false,
  withoutQuantity: false,
  withoutCurrency: false,
  textWidth: 0,
  showRemove: false,
  isShowStock: false,
  orderStatus: '',
  isDetail: false,
  orderId: '',
  promotionRules: [],
  onSelectPromo: () => {},
  onCancelPromo: () => {},
  onReady: () => {},
  onShow: () => {},
  onRemove: () => {},
  customer: {},
  sales_team: {},
  isQuotation: false,
  isShowDiscount2: false,
  isCopyItem: false,
  setDetailPromoData: () => {},
  isShowDetailPromo: false,
};

const dimension = Dimensions.get('window');
const fullWidth = dimension.width;
const imageSize = 40;
const trash = {
  width: 14,
  height: 18,
};
const icon = 12;

const ProductItem = (props) => {
  const {
    data = {},
    withoutDiscount = false,
    withoutPrice = false,
    withoutQuantity = false,
    withoutCurrency = false,
    textWidth = 0,
    showRemove = false,
    isShowStock = false,
    setDetailPromoData = () => {},
    orderStatus = '',
    isDetail = false,
    orderId = '',
    onSelectPromo = () => {},
    onCancelPromo = () => {},
    onReady = () => {},
    onShow = () => {},
    onRemove = () => {},
    customer = {},
    sales_team = {},
    isQuotation = false,
    isShowDiscount2 = false,
    isCopyItem = false,
    isShowDetailPromo = false,
  } = props;

  const item = data || {};
  const isSelectedRules = Boolean(item?.applied_promotion?.id);

  useEffect(() => {
    if (!withoutDiscount && isSelectedRules) {
      onReady();
    }
  }, []);

  const onShowProduct = (item) => {
    try {
      onShow(item);
    } catch (error) {}
  };

  const onRemoveProduct = (item) => {
    try {
      onRemove(item);
    } catch (error) {}
  };

  return (
    <View style={{ width: '100%' }}>
      <Product
        isFreeProduct={data.product_type == 'gwp_levelling_free_product'}
        product={item}
        isSelectedRules={isSelectedRules}
        showRemove={showRemove}
        withoutPrice={withoutPrice}
        withoutQuantity={withoutQuantity}
        withoutCurrency={withoutCurrency}
        textWidth={textWidth}
        withoutDiscount={withoutDiscount}
        isShowStock={isShowStock}
        orderStatus={orderStatus}
        isDetail={isDetail}
        orderId={orderId}
        onShowProduct={(val) => onShowProduct(val)}
        onRemoveProduct={() => onRemoveProduct()}
        onSelectPromo={(val) => onSelectPromo(val)}
        onCancelPromo={() => onCancelPromo()}
        sales_team={sales_team}
        customer={customer}
        isQuotation={isQuotation}
        isShowDiscount2={isShowDiscount2}
        isCopyItem={isCopyItem}
        setDetailPromoData={setDetailPromoData}
        isShowDetailPromo={isShowDetailPromo}
      />
      {isSelectedRules && item?.free_product?.id ? (
        <Product
          isFreeProduct
          product={item.free_product}
          isSelectedRules={isSelectedRules}
          showRemove={showRemove}
          withoutPrice={withoutPrice}
          withoutQuantity={withoutQuantity}
          textWidth={textWidth}
          withoutDiscount={withoutDiscount}
          isShowStock={isShowStock}
          orderStatus={orderStatus}
          orderId={orderId}
          setDetailPromoData={setDetailPromoData}
          isShowDetailPromo={isShowDetailPromo}
          onShowProduct={(val) => onShowProduct(val)}
          onRemoveProduct={() => onRemoveProduct()}
          onSelectPromo={(val) => onSelectPromo(val)}
          onCancelPromo={() => onCancelPromo()}
          sales_team={sales_team}
          customer={customer}
          isQuotation={isQuotation}
          isCopyItem={isCopyItem}
        />
      ) : (
        false
      )}
    </View>
  );
};

const Product = ({
  product = {},
  showRemove,
  isShowStock,
  orderStatus,
  isDetail,
  orderId,
  setDetailPromoData = () => {},
  isShowDetailPromo = false,
  withoutPrice = false,
  withoutQuantity = false,
  withoutCurrency = false,
  textWidth = 0,
  withoutDiscount,
  isFreeProduct = false,
  customer = {},
  sales_team = {},
  isQuotation = false,
  isShowDiscount2 = false,
  onShowProduct = () => {},
  onRemoveProduct = () => {},
  onSelectPromo = () => {},
  onCancelPromo = () => {},
  isCopyItem = false,
}) => {
  const [promoLoading, setPromoLoading] = useState(false);
  const [productName, setProductName] = useState('');
  const [promotionProducts, setPromotionProducts] = useState([]);

  const getPromoReminderList = async (product) => {
    setPromotionProducts(product.promo_reminder_list || []);
    setProductName(product?.name);
  };

  const closeProductPromo = () => {
    setProductName('');
    setPromoLoading(false);
    setPromotionProducts([]);
  };

  const isLessQuantity = (pr) => {
    const qty =
      pr.quantity && !isNaN(Number(pr.quantity)) ? Number(pr.quantity) : 0;
    const stock =
      pr.stock_available && !isNaN(Number(pr.stock_available))
        ? Number(pr.stock_available)
        : 0;
    if (qty == 0 || stock == 0) {
      return true;
    }
    return qty > stock;
  };

  const isLessStock = isShowStock && isLessQuantity(product);
  const isSelectedRules = Boolean(product?.applied_promotion?.id);
  const isAvailablePromo = Boolean(product.is_promo_available);
  const productImage = product?.combination?.image
    ? product.combination.image
    : product.image;

  const mobileWrapperWidth = textWidth ? textWidth : fullWidth - 80;
  const mobileWidth = fullWidth - 130;

  const finalPrice = product.total_price_before_tax
    ? product.total_price_before_tax
    : product.total_price
    ? product.total_price
    : product.price;

  const isPriceDiffer = useMemo(() => {
    if (isQuotation) {
      return isQuotationAmountDiff(
        finalPrice,
        product.quotation_total_price_before_tax,
      );
    } else {
      return false;
    }
  }, [isQuotation, finalPrice, product]);

  const RenderImage = useMemo(
    () => (
      <Image
        style={{ width: imageSize, height: imageSize }}
        width={imageSize}
        height={imageSize}
        compressWidth={imageSize}
        source={productImage}
      />
    ),
    [productImage],
  );

  return (
    <TouchableOpacity
      onPress={() => (isFreeProduct ? null : onShowProduct(product))}
      activeOpacity={isFreeProduct ? 1 : 0.6}
      style={[
        {
          flexDirection: 'row',
          borderBottomColor: Colors.grey0,
          borderBottomWidth: 1,
          paddingVertical: 17,
          paddingHorizontal: 15,
          maxWidth: isWeb ? '100%' : fullWidth,
          backgroundColor: Colors.white,
        },
        isFreeProduct ? { backgroundColor: Colors.blue5 } : {},
        isLessStock ? { backgroundColor: Colors.red2 } : {},
      ]}>
      <View style={styles.imageWrapper}>{RenderImage}</View>
      <View style={{ width: isWeb ? 'calc(100% - 45px)' : mobileWrapperWidth }}>
        {isFreeProduct ? (
          <SociollaText
            type="medium"
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              maxWidth: isWeb ? 'calc(100% - 45px)' : mobileWidth,
              fontSize: 14,
              marginBottom: 10,
            }}>
            FREE
          </SociollaText>
        ) : (
          false
        )}
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          {!isCopyItem ? (
            <SociollaText
              type="medium"
              numberOfLines={1}
              ellipsizeMode="tail"
              style={{
                maxWidth: isWeb ? 'calc(100% - 45px)' : mobileWidth,
                fontSize: 14,
              }}>
              {[
                product?.combination?.reference
                  ? `[${product.combination.reference}] `
                  : product?.sku
                  ? `[${product.sku}] `
                  : ``,
                product?.name || '',
              ].join('')}
            </SociollaText>
          ) : (
            <View
              style={{ maxWidth: isWeb ? 'calc(100% - 45px)' : mobileWidth }}>
              {product?.combination?.reference || product?.sku ? (
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 4,
                  }}>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, marginRight: 6 }}>
                    {product?.combination?.reference || product?.sku}
                  </SociollaText>
                  <TouchableOpacity
                    onPress={() => {
                      const ref =
                        product?.combination?.reference || product?.sku || '';
                      if (ref) {
                        if (isWeb) {
                          navigator.clipboard.writeText(ref);
                        } else {
                          Clipboard.setString(ref);
                        }
                        Toast.show({
                          type: 'success',
                          text1: 'Reference copied!',
                        });
                      }
                    }}>
                    <Image
                      style={{ width: 18, height: 18 }}
                      width={18}
                      height={18}
                      source={require('@assets/img/icons/copy.svg')}
                      svg={true}
                    />
                  </TouchableOpacity>
                </View>
              ) : null}

              {product?.name ? (
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, marginRight: 6 }}>
                    {product.name}
                  </SociollaText>
                  <TouchableOpacity
                    onPress={() => {
                      if (isWeb) {
                        navigator.clipboard.writeText(product.name);
                      } else {
                        Clipboard.setString(product.name);
                      }
                      Toast.show({
                        type: 'success',
                        text1: 'Product name copied!',
                      });
                    }}>
                    <Image
                      style={{ width: 18, height: 18 }}
                      width={18}
                      height={18}
                      source={require('@assets/img/icons/copy.svg')}
                      svg={true}
                    />
                  </TouchableOpacity>
                </View>
              ) : null}
            </View>
          )}
          {showRemove && !isFreeProduct ? (
            <TouchableOpacity
              style={{
                width: 30,
                height: trash.height,
                justifyContent: 'flex-end',
              }}
              activeOpacity={0.6}
              onPress={() => onRemoveProduct()}>
              <Image
                style={{
                  width: trash.width,
                  height: trash.height,
                  alignSelf: 'flex-end',
                  marginRight: 10,
                }}
                width={trash.width}
                height={trash.height}
                source={require('@assets/img/icons/trash-grey.svg')}
                svg={true}
              />
            </TouchableOpacity>
          ) : (
            false
          )}
        </View>
        <SociollaText
          style={{ fontSize: 13, color: Colors.grey1, marginVertical: 10 }}>
          {product.brand && product.brand.name ? product.brand.name : '-'}
        </SociollaText>
        {!withoutPrice ? (
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}>
            <View>
              {!withoutQuantity ? (
                <SociollaText style={{ fontSize: 13, color: Colors.grey1 }}>
                  {product.quantity} Pcs
                </SociollaText>
              ) : (
                false
              )}
              {isShowStock ? (
                <SociollaText
                  style={{
                    fontSize: 13,
                    color: isLessStock ? Colors.red0 : Colors.green1,
                  }}>
                  Available stock:{' '}
                  {product.stock_available ? product.stock_available : 0} Pcs
                </SociollaText>
              ) : (
                false
              )}
              {isShowDiscount2 && product?.discount_percentage2?.name ? (
                <View
                  style={{
                    marginTop: 5,
                    width: isWeb ? '100%' : mobileWidth * 0.7,
                  }}>
                  <SociollaText
                    style={{
                      fontSize: 11,
                      color: product?.discount_percentage2?.is_removed_by_oos
                        ? Colors.red0
                        : Colors.blue0,
                    }}>
                    Promo: {product.discount_percentage2.name}
                  </SociollaText>
                </View>
              ) : (
                false
              )}
              {isQuotation && !isWeb && (
                <View style={{ marginTop: 5 }}>
                  <SociollaText
                    style={{
                      fontSize: 14,
                      color: isPriceDiffer ? Colors.red0 : Colors.green1,
                    }}>
                    Quotation Price:{' '}
                    {currency(product.quotation_total_price_before_tax, true)}
                  </SociollaText>
                </View>
              )}
              {['need_approval', 'approved', 'rejected', 'cancelled'].includes(
                orderStatus,
              ) && product.is_out_of_stock ? (
                <SociollaText
                  style={{
                    fontSize: 13,
                    color: Colors.red0,
                  }}>
                  Initial Quantity:{' '}
                  {product.initial_quantity ? product.initial_quantity : 0} Pcs
                </SociollaText>
              ) : (
                false
              )}
              {product?.estimation_order_value ? (
                <SociollaText
                  style={{
                    fontSize: 13,
                    color: Colors.grey1,
                  }}>
                  Suggestion Order:{' '}
                  {product?.estimation_order_value
                    ? product.estimation_order_value
                    : 0}{' '}
                  Pcs
                </SociollaText>
              ) : (
                false
              )}
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              {!isDetail &&
              !isFreeProduct &&
              product.is_promo_reminder &&
              !product?.discount_percentage2?.id &&
              !isSelectedRules ? (
                <TouchableOpacity
                  activeOpacity={0.6}
                  style={{ marginRight: 15, marginTop: -2 }}
                  onPress={() => getPromoReminderList(product)}>
                  <Image
                    style={{
                      width: 14,
                      height: 14,
                    }}
                    width={14}
                    height={14}
                    source={require('@assets/img/icons/info-blue.svg')}
                    svg={true}
                  />
                </TouchableOpacity>
              ) : (
                false
              )}
              {isQuotation && isWeb && (
                <View style={{ marginRight: 20 }}>
                  <SociollaText
                    style={{
                      fontSize: 14,
                      color: isPriceDiffer ? Colors.red0 : Colors.green1,
                    }}>
                    {currency(product.quotation_total_price_before_tax, true)}
                  </SociollaText>
                </View>
              )}
              {!withoutCurrency ? (
                <View style={{ flexDirection: 'column', gap: 10 }}>
                  <SociollaText style={{ fontSize: 14 }}>
                    {currency(isFreeProduct ? 0 : finalPrice, true)}
                  </SociollaText>
                  {[
                    'need_approval',
                    'approved',
                    'rejected',
                    'cancelled',
                  ].includes(orderStatus) && product.is_out_of_stock ? (
                    <SociollaText
                      style={{
                        fontSize: 14,
                        color: Colors.red0,
                      }}>
                      {currency(
                        product.initial_total_price_before_tax
                          ? product.initial_total_price_before_tax
                          : 0,
                        true,
                      )}
                    </SociollaText>
                  ) : (
                    false
                  )}
                </View>
              ) : (
                false
              )}
            </View>
          </View>
        ) : (
          false
        )}
        {(!isFreeProduct ||
          product?.product_type == 'gwp_levelling_free_product') &&
        !withoutDiscount &&
        (isSelectedRules || isAvailablePromo) ? (
          <View style={{ width: '100%', marginTop: 10 }}>
            {isSelectedRules ? (
              <TouchableOpacity
                activeOpacity={0.6}
                style={{ flexDirection: 'row', alignItems: 'center' }}
                onPress={() => onCancelPromo()}>
                {!isFreeProduct ? (
                  <Image
                    style={{
                      width: icon,
                      height: icon,
                      marginRight: 10,
                      marginTop: -3,
                    }}
                    width={icon}
                    height={icon}
                    source={require('@assets/img/icons/close-blue.svg')}
                    svg={true}
                  />
                ) : null}
                <SociollaText style={styles.promoLabel}>
                  Promo Applied: {product?.applied_promotion?.name}
                </SociollaText>
              </TouchableOpacity>
            ) : (
              <View style={{ width: '100%' }}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}>
                  <Image
                    style={{
                      width: icon,
                      height: icon,
                      marginRight: 10,
                      marginTop: -3,
                    }}
                    width={icon}
                    height={icon}
                    source={require('@assets/img/icons/info-blue.svg')}
                    svg={true}
                  />
                  <SociollaText style={styles.promoLabel}>
                    Promo Available
                  </SociollaText>
                </View>
                <View style={{ width: isWeb ? '50%' : '100%' }}>
                  <SelectBox
                    label="Select Promotion"
                    hideLabel={true}
                    options={product?.promo_available_list || []}
                    value={product?.applied_promotion}
                    placeholder="Select Promotion"
                    trackBy="id"
                    labelKey="name"
                    onChange={async (value) => {
                      if (value?.id) {
                        onSelectPromo(value);
                      }
                    }}
                    withCallback={false}
                    isShowDetail={true}
                    setDetail={setDetailPromoData}
                    isShowDetailPromo={isShowDetailPromo}
                  />
                </View>
              </View>
            )}
          </View>
        ) : (
          false
        )}
      </View>
      <ModalFull
        title={`Promo ${productName}`}
        show={Boolean(productName)}
        onClose={() => closeProductPromo()}>
        {promoLoading ? (
          <View style={{ padding: 20 }}>
            <Loader />
          </View>
        ) : promotionProducts?.length ? (
          <View
            style={{
              flex: 1,
              marginTop: isWeb ? 5 : 0,
            }}>
            <ScrollContainer style={{ maxHeight: dimension.height - 150 }}>
              {promotionProducts.map((item, idx) => (
                <View
                  style={[
                    styles.promoItem,
                    idx == 0
                      ? { borderTopColor: Colors.grey0, borderTopWidth: 1 }
                      : {},
                    isWeb && idx == promotionProducts.length - 1
                      ? { borderBottomWidth: 0 }
                      : {},
                  ]}
                  key={`promo-product-${idx}`}>
                  <SociollaText
                    style={[styles.promoText, { width: 25, marginRight: 10 }]}>
                    {idx + 1}.
                  </SociollaText>
                  <SociollaText style={styles.promoText}>
                    {item?.description ? item.description : '-'}
                  </SociollaText>
                </View>
              ))}
            </ScrollContainer>
          </View>
        ) : (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 20,
            }}>
            <SociollaText style={styles.promoText}>
              Belum ada promo untuk produk ini.
            </SociollaText>
          </View>
        )}
      </ModalFull>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  imageWrapper: {
    backgroundColor: Colors.white,
    justifyContent: 'center',
    marginRight: 10,
    overflow: 'hidden',
    width: imageSize,
    height: imageSize,
  },
  promoLabel: {
    width: '100%',
    fontSize: 13,
    flexDirection: 'row',
    alignItems: 'center',
    color: Colors.blue0,
  },
  promoText: { fontSize: 13 },
  promoItem: {
    flexDirection: 'row',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
});

ProductItem.propTypes = propTypes;
ProductItem.defaultProps = defaultProps;

export default ProductItem;
